export const getStartDate = (date) => {
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getEndDate = (date) => {
  date.setHours(23, 59, 59, 999);
  return date;
};
